module.exports = __webpack_public_path__ + "img/android.3dcda647.png";